import { Button, FormControl, InputLabel, Select, Stack } from '@mui/material'
import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro'
import { Clear } from '@mui/icons-material'
import { stackGap } from '../../../Constants&Theme/Spacing'
import * as React from 'react'
import { listFromCodes, listFromKV } from '../../../Functions/ListItemGenerator'
import { useHealthContext } from '../../../Contexts/Modules/HealthModule/HealthModule'
import { useUserContext } from '../../../Contexts/UserConfig'

export interface ResultsFilters {
  FacilityID: string | number
  SampleType: string | number
  ResultID: string | number
  DateEnteredStart: Date | null
  DateEnteredEnd: Date | null
}
function ResultsReportDGToolbar({
  dgFilters,
  setDGFilters,
}: {
  dgFilters: ResultsFilters
  setDGFilters: any
}) {
  const { loginConfig, loadingConfig } = useUserContext()
  const { screenFacilityQuery } = useHealthContext()

  return (
    <GridToolbarContainer sx={{ width: 1, p: 1 }}>
      <Stack
        direction={'row'}
        gap={stackGap.row / 2}
        width={1}
        display={'flex'}
      >
        <GridToolbarExport
          csvOptions={{ allColumns: true }}
          printOptions={{ disableToolbarButton: true }}
        />
        <FormControl
          size="small"
          sx={{ flex: 1 }}
        >
          <InputLabel>Recipient Lab</InputLabel>
          <Select
            inputProps={{ 'aria-label': 'FacilityInput' }}
            label={'Recipient Lab'}
            value={dgFilters?.FacilityID ?? ''}
            onChange={(e) =>
              setDGFilters((f: any) => {
                return { ...f, FacilityID: e.target.value }
              })
            }
          >
            {listFromKV(
              screenFacilityQuery.data ?? [],
              screenFacilityQuery.isLoading,
              dgFilters?.FacilityID,
            )}
          </Select>
        </FormControl>
        <FormControl
          size="small"
          sx={{ flex: 1 }}
        >
          <InputLabel>Sample Type</InputLabel>
          <Select
            inputProps={{ 'aria-label': 'SampleTypeInput' }}
            label={'Sample Type'}
            value={dgFilters?.SampleType ?? ''}
            onChange={(e) =>
              setDGFilters((f: any) => {
                return { ...f, SampleType: e.target.value }
              })
            }
          >
            {listFromCodes(loginConfig, 'SampleRunTypeID', loadingConfig)}
          </Select>
        </FormControl>
        <FormControl
          size="small"
          sx={{ flex: 1 }}
        >
          <InputLabel>Result</InputLabel>
          <Select
            inputProps={{ 'aria-label': 'ResultInput' }}
            label={'Result'}
            value={dgFilters?.ResultID ?? ''}
            onChange={(e) =>
              setDGFilters((f: any) => {
                return { ...f, ResultID: e.target.value }
              })
            }
          >
            {listFromCodes(loginConfig, 'ResultID', loadingConfig)}
          </Select>
        </FormControl>
        {/*<FormControl*/}
        {/*  size="small"*/}
        {/*  sx={{ flex: 1 }}*/}
        {/*>*/}
        {/*  <InputLabel>Date Entered</InputLabel>*/}
        {/*  <DesktopDateRangePicker*/}
        {/*    size="small"*/}
        {/*    sx={{ minWidth: 280 }}*/}
        {/*    // value={[dgFilters?.DateEnteredStart, dgFilters?.DateEnteredEnd]}*/}
        {/*    onChange={(newValue) =>*/}
        {/*      setDGFilters((f: any) => {*/}
        {/*        return {*/}
        {/*          ...f,*/}
        {/*          DateEnteredStart: newValue?.[0],*/}
        {/*          DateEnteredEnd: newValue?.[1],*/}
        {/*        }*/}
        {/*      })*/}
        {/*    }*/}
        {/*  />*/}
        {/*</FormControl>*/}
        <Button
          variant={'outlined'}
          startIcon={<Clear />}
          color={'warning'}
          onClick={() => setDGFilters({})}
        >
          Clear Filters
        </Button>
      </Stack>
    </GridToolbarContainer>
  )
}

export default ResultsReportDGToolbar
